import { useMemo } from 'react';
import { usePathname } from 'next/navigation';
import { Link, Text, useTranslation, useUi } from '@weareconceptstudio/core';

//* Helpers
import { config } from '@/helpers';

//* Styles
import MenuBarStyle from './style';

//* Components
import Button from '@/components/Button';

const MenuBar = ({ className = '' }) => {
	const { isBurgerMenuOpen, closeBurgerMenu } = useUi();

	const pathname = usePathname();
	const { selectedLang } = useTranslation();

	const cleanedPathname = useMemo(() => {
		return selectedLang ? pathname.replaceAll(`/${selectedLang}`, '') : pathname;
	}, [pathname, selectedLang]);

	const isHover = useMemo(() => {
		const targetPaths = [config.routes.aboutUs.path, config.routes.products.path, config.routes.benefits.path, config.routes.recipes.path, config.routes.blog.path, config.routes.faq.path];

		return targetPaths.includes(cleanedPathname);
	}, [cleanedPathname]);

	//! Menu Bar
	const menuBar = useMemo(() => {
		return Object.entries(config.routes).map((item, key) => {
			if (item[1].isHeader) {
				return (
					<Link
						key={key}
						url={item[1].path}
						className={`menu-bar-item-link ${isHover ? 'hover-type' : ''} ${pathname.includes(item[1].path) ? 'active' : ''}`}
					>
						<Text
							text={item[1].name}
							className={`p2 font-fss-regular light-gray-1000 menu-bar-item`}
						/>
					</Link>
				);
			}
		});
	}, [pathname, isHover]);

	return (
		<MenuBarStyle className={`menu-bar-container ${className}`}>
			<div className='menu-bar-inner-container'>
				<div className='menu-bar-block'>{menuBar}</div>

				{isBurgerMenuOpen ? (
					<Button
						className={'burger-menu-btn'}
						url={config.routes.contactUs.path}
						text={config.routes.contactUs.name}
						onClick={() => closeBurgerMenu()}
					/>
				) : null}
			</div>
		</MenuBarStyle>
	);
};

export default MenuBar;
